import AuthSlice from "./AuthSlice";
import FiltergetSlice from "./FiltergetSlice";
import GetCategorySlice from "./GetCategorySlice";
import ProductSlice from "./ProductSlice";
import UserSlice from './UserSlice';
import { combineReducers } from 'redux';
import WishListSlice from "./WishListSlice";
import AddToCartSlice from "./AddToCartSlice";
import DeliveryAddressSlice from "./DeliveryAddressSlice";
import CountrySlice from "./CountrySlice";
export const rootReducer = combineReducers({
    AuthSlice : AuthSlice,
    ProductSlice : ProductSlice,
    UserSlice : UserSlice,
    GetCategorySlice : GetCategorySlice,
    FiltergetSlice : FiltergetSlice,
    WishListSlice : WishListSlice,
    AddToCartSlice : AddToCartSlice,
    DeliveryAddressSlice : DeliveryAddressSlice,
    CountrySlice: CountrySlice
});
// const persistConfig = {
//   key: 'root',
//   storage,
// };
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export default persistedReducer;